import { type UseQueryResult, useQuery } from '@tanstack/react-query'
import { genericApi } from '~/api'

export interface SessionParticipant {
  id: number
  first_name: string
  last_name: string
  email: string
  username: string
}

export interface SessionCourse {
  id: number
  name: string
  deleted_at: string | null
}

export interface AppstreamSession {
  id: number
  user_id: string | null
  region: string | null
  fleet_name: string | null
  session_start_time: string | null
  session_end_time: string | null
  session_duration_in_seconds: number | null
  session_duration_in_seconds_time_span: string
  participant?: SessionParticipant | null
  course?: SessionCourse | null
}

interface SessionPagination {
  current_page: number
  per_page: number
  total: number
}

export interface AppstreamSessionsResponse {
  data: AppstreamSession[]
  meta: SessionPagination
  total_duration_in_hours: number
}

export interface AppstreamSessionParams {
  course_id?: number
  include_course?: 0 | 1
  region_code?: string | null
  search?: string
  page: number
  per_page: number
  order_by: string
  direction: 'asc' | 'desc'
}

export const useAppstreamSessionsQuery = (
  params: AppstreamSessionParams,
  enabled: boolean
): UseQueryResult<AppstreamSessionsResponse> => {
  return useQuery({
    queryKey: ['appstream-sessions', params],
    queryFn: async () => {
      const { data } = await genericApi.getAppstreamSessions(params)
      return data
    },
    enabled,
    keepPreviousData: true
  })
}
